import {
  ArticleList,
} from "@babackapp/customer-ui/components/article";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { useDraftReturn } from "@babackapp/return-widget-components/hooks/use-draft-return";
import { useReturnableItems } from "@babackapp/return-widget-components/hooks/use-returnable-items";
import { useNonReturnableItems } from "@babackapp/return-widget-components/hooks/use-non-returnable-items";
import { usePublicShop } from "@babackapp/return-widget-components/queries/use-public-shop";
import { UserPortalCallout } from "@babackapp/return-widget-components/components/user-portal-callout";
import { useWidgetParams } from "../../hooks/use-widget-params";
import { LineItemRow } from "./line-item-row";
import { NonReturnableRow } from "./non-returnable-row";

export function LineItemSelection() {
  const { orderId, shopSlug, shopId } = useWidgetParams();
  const { data: shop } = usePublicShop(shopId);
  const allReturnableItems = useReturnableItems(orderId, shopSlug);
  const nonReturnableItems = useNonReturnableItems(orderId);
  const draft = useDraftReturn(orderId);
  const singleArticleOnly = shop?.preferences?.singleArticleReturnOnly === true;
  const draftIds = new Set(draft?.lineItems.map((li) => li.lineItemId) ?? []);
  const returnableLineItems =
    singleArticleOnly && draftIds.size > 0
      ? []
      : allReturnableItems.filter((li) => !draftIds.has(li.line_item_id));

  return (
    <WidgetPage>
      <Header>
        <HeaderTitle>Sélectionnez un article</HeaderTitle>
        <HeaderDescription>
          Sélectionnez l'article que vous souhaitez retourner.
        </HeaderDescription>
      </Header>

      <UserPortalCallout texts={shop?.preferences?.userPortal?.articleSelectionMessage} />

      <ArticleList className="cursor-pointer max-h-96 overflow-y-auto">
        {returnableLineItems.map((lineItem) => (
          <LineItemRow
            key={lineItem.line_item_id}
            lineItem={lineItem}
            orderId={orderId}
            shopId={shopId}
          />
        ))}
        {nonReturnableItems.map((item) => (
          <NonReturnableRow key={item.lineItem.line_item_id} item={item} />
        ))}
      </ArticleList>
    </WidgetPage>
  );
}
